import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HeroSection from "./HeroSection";
import AboutUs from "./AboutUs";
import OurValues from "./OurValues";
import OurCulture from "./OurCulture";
import Overview from "./Overview";
import OfficeLocations from "./OfficeLocations";
import TeamStructure from "./TeamStructure";
import Benifits from "./Benifits";
import OpenPositions from "./OpenPositions";
import CandidateApplication from "./CandidateApplication";
import styled from "styled-components";
import messageIcon from "Assets/newicons/user-interface/message/outline/message-outline-32px.svg";

const chatButton = styled.div`
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 80px;
  height: 80px;
  background: "red";
  border-radius: 50%;
  cursor: pointer;
  z-index: 1111;
`;

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class SubscriptionCareerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
      candidateApplication: false,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.openApplication = this.openApplication.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  openApplication() {
    this.setState({
      candidateApplication: true,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { value, candidateApplication } = this.state;
    return (
      <div>
        {candidateApplication ? (
          <CandidateApplication />
        ) : (
          <div>
            <HeroSection />
            <div style={{ padding: 64 }}>
              <AboutUs />
              <OurCulture />
              <OurValues />
              <Overview />
              <Benifits />
              <TeamStructure />
              <OfficeLocations />
              <OpenPositions openApplication={this.openApplication} />
            </div>
            <div
              className="chatbutton"
              style={{
                position: "fixed",
                bottom: 32,
                right: 32,
                width: 80,
                height: 80,
                background: "#fff",
                borderRadius: "50%",
                cursor: "pointer",
                zIndex: 1111,
                boxShadow: "0 7px 24px 0 rgba(0, 0, 0, 0.4)",
              }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: 24,
                  border: "solid 8px rgba(254, 241, 217, 0.7)",
                  background: "#faa500",
                  right: -10,
                  position: "absolute",
                  top: -5,
                }}
              ></div>
              <img src={messageIcon} className="vertical-center msg-icon"></img>
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles, { withTheme: true })(withSnackbar(SubscriptionCareerPage)),
);
